export const PROFICIENCY_THRESHOLDS = { GROWTH_OPPORTUNITIES: 60, PROFICIENCIES: 80 };

export const getProficiencyLabel = (score: number | null): string | null => {
  if (score == null) return null;
  if (score >= PROFICIENCY_THRESHOLDS.PROFICIENCIES) return "Advanced";
  if (score >= PROFICIENCY_THRESHOLDS.GROWTH_OPPORTUNITIES) return "Intermediate";
  return "Foundational";
};

export const formatChartDate = (dateString: string | undefined): string => {
  if (!dateString) return "";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return "";
  return `${d.getMonth() + 1}.${d.getFullYear()}`;
};
